import { UNIT } from "../../constants/configuration";
import { getColors } from "../../utils";

const getStyles = () => {
  const colors = getColors();

  return {
    space: {
      padding: `${UNIT * 0.875}px 0px`,
    },
    boxContainer: {
      textAlign: "center" as const,
      gap: "20px",
      alignSelf: "stretch",
      marginBottom: "30px",
    },
    welcomeTitle: {
      alignSelf: "stretch",
      textAlign: "center" as const,
      paddingBottom: "8px",
    },
    welcomeSubtitle: {
      alignSelf: "stretch",
      color: colors.bgDarkGrey,
      textAlign: "center" as const,
      fontSize: "14px",
    },
    signupTitle: {
      fontWeight: 900,
      padding: `${UNIT * 0.5}px`,
    },
    signInContainer: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      gap: "20px",
      alignSelf: "stretch",
      marginBottom: "40px",
    },
    container: {
      display: "flex",
      padding: "32px 40px",
      flexDirection: "column",
      alignItems: "center",
      gap: "40px"
    },
    close: {
      cursor: "pointer",
      float: "right",
      position: "absolute",
      right: "20px",
      top: "20px",
    },
  };
};

export default getStyles;